import { JoyspaceState } from "@/models/joyspace";
import React, { useState, useEffect, useCallback, useMemo, useContext } from "react";
import events from "../../../context/events";
import Icon, { Icons } from "../../../Icon";
import { Order, Sort } from "./config";
import { connect } from "dvajs";
import "./index.less";
import { Dropdown } from "antd";
import { notUseJoySpaceOffline } from "@/components/Joyspace/util";
import { analysisLog } from "@/utils/logAnalytics";
import { useNavigator } from "@/utils/NetworkCheck";
import GlobalContext from "@/context/GlobalContext";
import { MenusType } from "@/components/Joyspace/types";

export type menuItem<T> = {
  text?: string;
  order: Order;
  sort: string;
} & T;

interface Props<T> {
  onChange?: (o: menuItem<T>) => void;
  restoreOrder?: () => void;
  menu: menuItem<T>[];
  isArrowDownIcon?: boolean;
  filterInfo: any;
  setFilterInfo: Function;
  defaultFilterInfo: any;
  callback: Function;
  from?: string;
}

function Filters<T>(props: Props<T>) {
  const {
    isArrowDownIcon = false,
    filterInfo,
    defaultFilterInfo,
    callback,
    setFilterInfo,
    onChange,
    from = ""
  } = props;
  const [menu, select] = useState({ ...props.menu[0] });
  const [status, setStatus] = useState(false);
  const [isShowDropupIcon, setIsShowDropupIcon] = useState(false);
  const [visible, setVisible] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const { onLine } = useContext(GlobalContext);
  useMemo(() => {
    if (notUseJoySpaceOffline()) {
      return;
    }
    setDisabled(!onLine);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);
  const onChangeMenu = useCallback(
    (parames: menuItem<T>) => {
      const result = props.menu.find((item) => item.sort === parames.sort);
      if (result) {
        const title = result?.text || props.menu[0].text;
        parames.text = title;
        select(parames);
        return;
      }
      select({ ...props.menu[0] });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [menu]
  );
  useEffect(() => {
    onChangeMenu(defaultFilterInfo || filterInfo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultFilterInfo, filterInfo]);
  const getPath = useCallback(() => {
    return typeof from === "string" && from?.toLowerCase() === MenusType.RECENT;
  }, [from]);
  const menus = useMemo(() => {
    const sort = getPath() ? defaultFilterInfo.sort : filterInfo.sort;
    return (
      <div data-menu className="joyspace-layer-menu joypsace-filter-menu-lists">
        <ul>
          {props.menu.map((option, index) => {
            return (
              <li
                className={
                  filterInfo.order === option.order && sort === option.sort
                    ? "joyspace-filter-checked"
                    : ""
                }
                onClick={(e) => {
                  analysisLog(
                    "xtbg_jzb_joyspace_home_1676548210761",
                    "37",
                    from,
                    option.sort,
                    option.order
                  );
                  if (disabled) {
                    return;
                  }
                  e.preventDefault();
                  e.stopPropagation();
                  select(option);
                  // setSelectIndex(index);
                  setStatus(false);
                  onChange?.(option);
                  events.emit("list.check");
                  // console.log(option, 'optionoptionoption');
                  if (defaultFilterInfo) {
                    callback(option.order, option.sort);
                    return;
                  }
                  setFilterInfo(option.order, option.sort);
                }}
                key={index}
              >
                <span
                  style={{
                    fontSize: 12
                  }}
                >
                  {option.text}
                </span>
                {/* {index === selectIndex && Icons.dropfinishMenu} */}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }, [
    getPath,
    defaultFilterInfo,
    filterInfo.order,
    filterInfo.sort,
    props.menu,
    from,
    disabled,
    onChange,
    setFilterInfo,
    callback
  ]);
  const onVisibleChange = useCallback((val) => {
    setVisible(val);
  }, []);
  const setClassName = useCallback(() => {
    let classNames = "joyspace-list-filter ";
    if (disabled) {
      classNames += "joyspace-select-filter_disabled";
    }
    if (visible) {
      classNames += "joyspace-filter-checked";
    }
    return classNames;
  }, [disabled, visible]);
  const FilterIcon = useMemo(() => {
    if (getPath()) {
      return (
        <>
          <span data-title>{menu.text}</span>
          <Icon className="icon" type="iconicon_up" />
        </>
      );
    }
    return (
      <>
        <span data-title>{menu.text?.substring(0, menu.text.length - 2)}</span>
        <Icon
          className={menu.order === Order.ASC ? "icon" : ""}
          type={isArrowDownIcon ? "iconjs_ilist_arrowdown" : "iconic_app_paixu"}
        />
      </>
    );
  }, [getPath, isArrowDownIcon, menu.order, menu.text]);
  return (
    <div className={setClassName()}>
      <Dropdown
        trigger={["click"]}
        onVisibleChange={onVisibleChange}
        overlay={menus}
        disabled={disabled}
        overlayClassName="joyspace-share-dropdown"
      >
        <div className="joyspace-select-filter">
          {/* {isArrowDownIcon ? (
            <Icon
              className={menu.order === Order.ASC ? "icon" : ""}
              type="iconjs_ilist_arrowdown"
            />
          ) : (
            <Icon className={menu.order === Order.ASC ? "icon" : ""} type="iconic_app_paixu" />
          )} */}
          {FilterIcon}
        </div>
      </Dropdown>
    </div>
  );
}

function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  // console.log(joyspace, ' joyspace.folderInfo===>');
  return {
    filterInfo: joyspace.filterInfo
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setFilterInfo(order = Order.DESC, sort = Sort.UpDateTime) {
      return dispatch({
        type: "joyspace/setFilterInfo",
        payload: {
          order,
          sort
        }
      });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
